module.exports = __webpack_public_path__ + "static/media/kredyt_26.36af9c9d.png";